/**
 * Pure FIFO-cap helper for the toast queue. Extracted from `toast-store.ts`
 * so it can be unit-tested without pulling in zustand at module load.
 * Per ADR-0077 / Phase 5.
 */

export const MAX_TOASTS = 3;

export function appendCapped<T>(queue: readonly T[], next: T, cap: number = MAX_TOASTS): T[] {
  const out = [...queue, next];
  while (out.length > cap) out.shift();
  return out;
}
